import {
  Vector3,
  Vector2,
  DataTexture,
  RGBAFormat,
  FloatType
} from 'three'
import {
  Effect
} from 'postprocessing'

// Using rollup-plugin-string to import text files.
// import fragment from "./shader.frag";

export class FireworkEffect extends Effect {
  constructor () {
    var fragment = `
#define MAX_ITEMS 512
#define HEIGHT 4
//uniform vec2 fireworks[MAX_ITEMS];
uniform sampler2D fireworkData;
uniform int numFireworks;
void mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {

  float intensity = 0.0;
  vec3 rgbIntensity = vec3(0.0,0.0,0.0);
  float halfTexelx = float(texelSize.x)/2.0;
  float halfTexely = float(texelSize.y)/2.0;
  float tWidth = 1./float(MAX_ITEMS);
  float tHeight = 1./float(HEIGHT);
  
  for(int i=0; i< MAX_ITEMS; i++)
  {
    if(numFireworks == i)
    {
      break;
    }
    
    vec4 pos = texture2D(fireworkData, vec2(float(i)*tWidth+halfTexelx,0.*tHeight+halfTexely));
    vec4 col = texture2D(fireworkData, vec2(float(i)*tWidth+halfTexelx,1.*tHeight+halfTexely));
    // vec4 pos = vec4(0.5,0.5,1.,1.);
    // vec4 col = vec4(1.,0.,0.,1.);
    //intensity = 1.0/pow((distance(pos.xy, uv)+1.),2.0)*pos.w;
    intensity = 1.0/pow(distance(pos.xy, uv)*40.+1.,3.0)*pos.w;
    //intensity=0.001;
    rgbIntensity = rgbIntensity + (col.xyz+intensity)*intensity;
  }
  outputColor = vec4(inputColor.rgb + rgbIntensity, inputColor.a);
    
  
}`
    /*

    http://www.songho.ca/opengl/gl_transform.html
    https://gamedev.stackexchange.com/questions/49677/mapping-3d-object-coordinates-to-2d-screen-coordinates-with-perspective-projecti
    http://webglfactory.blogspot.com/2011/05/how-to-convert-world-to-screen.html

    */
    super('FireworkEffect', fragment)
    this.fwObjects = {}
    this.camera = {}
    this.maxObjects = 512
    this.fireworkBuffer = new Float32Array(this.maxObjects * 4 * 4)
    this.dataTexture = new DataTexture(this.fireworkBuffer, this.maxObjects, 4, RGBAFormat, FloatType)
    // this.blendMode = new BlendMode(BlendFunction.ADD)
    this.uniforms = new Map([
      ['fireworkData', {
        value: this.dataTexture,
        type: 't'
      }],
      ['numFireworks', {
        value: 0,
        type: 'int'
      }]
    ])
  }
  setFireworkPoints (camera, fwObjects) {
    this.camera = camera
    this.fwObjects = fwObjects
    // for (let i = 0; i < 100; i++) {
    //   if (i < this.fwObjects.length) {
    //     this.uniforms.get("fireworks").value[i] = this.a3Dto2D(this.fwObjects[i])
    //   } else {
    //     this.uniforms.get("fireworks").value[i] = new Vector2(-1000.0, -1000.0)
    //   }

    // }

    var iterations = (this.maxObjects < this.fwObjects.length) ? this.maxObjects : this.fwObjects.length
    var width = this.maxObjects * 4
    var stride = 4 // Using RGBA
    // this.fireworkBuffer = new Float32Array(this.maxObjects*4*4)
    this.fireworkBuffer.fill(0)
    for (var i = 0; i < iterations; i++) {
      let point = fwObjects[i].position.clone().project(this.camera)
      this.fireworkBuffer[i * stride] = (point.x + 1) / 2
      this.fireworkBuffer[i * stride + 1] = (point.y + 1) / 2
      this.fireworkBuffer[i * stride + 2] = point.z
      this.fireworkBuffer[i * stride + 3] = fwObjects[i].intensity
      this.fireworkBuffer[1 * width + i * stride] = fwObjects[i].color.r
      this.fireworkBuffer[1 * width + i * stride + 1] = fwObjects[i].color.g
      this.fireworkBuffer[1 * width + i * stride + 2] = fwObjects[i].color.b
      this.fireworkBuffer[1 * width + i * stride + 3] = 1.0
    }
    this.uniforms.get('numFireworks').value = iterations
    this.dataTexture.needsUpdate = true
    // this.worldTo2d = new Matrix4().multiplyMatrices(this.camera.projectionMatrix,this.camera.modelViewMatrix)
  }
  getDebug (debugPanel) {
    debugPanel['fwObjects'] = ''
    debugPanel['fwProjection'] = ''
    for (let i = 0; i < this.fwObjects.length; i++) {
      debugPanel['fwObjects'] += this.fwObjects[i].position.toArray()
      debugPanel['fwProjection'] += this.fwObjects[i].position.clone().project(this.camera).toArray()
    }
    // debugPanel["firework_uniforms"] = ""
    // for (let i = 0; i < this.uniforms.get("fireworks").value.length; i++) {
    //   debugPanel["firework_uniforms"] += this.uniforms.get("fireworks").value[i].toArray().toString()
    // }
  }
  a3Dto2D (a3dPoint) {
    var point = new Vector3(a3dPoint.x, a3dPoint.y, a3dPoint.z)
    point.project(this.camera)
    var out = new Vector2((point.x + 1) / 2, (point.y + 1) / 2)
    return out
  }
  // updateFireworkObjects(){
  // https://threejs.org/docs/#api/en/core/Object3D.traverseVisible
  // }
}
